import { registerTranslationRefresh, t as lnT } from '../i18n';
export const FEATURE_UPGRADE_MODAL_OPEN_EVENT = 'luckynote:open-feature-upgrade-modal';

export const FEATURE_UPGRADE_MODAL_PRESET = {
    AUDIO_TRANSCRIPTION: 'audio_transcription',
    TEXT_TO_SPEECH: 'text_to_speech',
    URL_TRANSCRIPT: 'url_transcript'
};

const makeTranslatedDEFAULT_HIGHLIGHTS = () => ([
    lnT('billing:getHigherAiLimitsAndFasterWorkflows'),
    lnT('billing:unlockAdvancedAudioAndVoiceTooling'),
    lnT('billing:keepEverythingInOneSearchableWorkspace')
]);
let DEFAULT_HIGHLIGHTS = makeTranslatedDEFAULT_HIGHLIGHTS();
registerTranslationRefresh(() => { DEFAULT_HIGHLIGHTS = makeTranslatedDEFAULT_HIGHLIGHTS(); });

const makeTranslatedPRESET_CONFIG = () => ({
    [FEATURE_UPGRADE_MODAL_PRESET.AUDIO_TRANSCRIPTION]: {
        badge: lnT('billing:audioFeature'),
        title: lnT('billing:unlockAudioTranscription'),
        subtitle: lnT('billing:turnRecordingsIntoCleanTextWithTimestamps'),
        highlights: [
            lnT('billing:transcribeUploadedAudioAndVideoFiles'),
            lnT('billing:autoTimestampsForQuickScanningAndEdits'),
            lnT('billing:useAdvancedTranscriptionOptionsWhenNeeded')
        ],
        ctaLabel: lnT('billing:upgradeToTranscribe'),
        planHint: lnT('billing:availableOnEligiblePaidPlans')
    },
    [FEATURE_UPGRADE_MODAL_PRESET.TEXT_TO_SPEECH]: {
        badge: lnT('billing:voiceFeature'),
        title: lnT('billing:unlockAiVoiceNotes'),
        subtitle: lnT('billing:generateNaturalVoiceAudioFromTitlesAnd'),
        highlights: [
            lnT('billing:createAudioFromNoteTitlesAndFull'),
            lnT('billing:previewDifferentVoicesBeforeGenerating'),
            lnT('billing:saveShareableVoiceNotesDirectlyInYour')
        ],
        ctaLabel: lnT('billing:upgradeForVoiceNotes'),
        planHint: lnT('billing:availableOnEligiblePaidPlans')
    },
    [FEATURE_UPGRADE_MODAL_PRESET.URL_TRANSCRIPT]: {
        badge: lnT('billing:transcriptFeature'),
        title: lnT('billing:getTranscriptsFromVideoLinks'),
        subtitle: lnT('billing:saveTheSpokenContentFromSupportedVideos'),
        highlights: [
            lnT('billing:turnSupportedVideoLinksIntoSearchableText'),
            lnT('billing:keepTheTranscriptWithTheOriginalNote'),
            lnT('billing:useItLaterForReviewsAndAi')
        ],
        ctaLabel: lnT('billing:upgradeForTranscripts'),
        planHint: lnT('billing:availableOnEligiblePaidPlans')
    }
});
let PRESET_CONFIG = makeTranslatedPRESET_CONFIG();
registerTranslationRefresh(() => { PRESET_CONFIG = makeTranslatedPRESET_CONFIG(); });

const sanitizeHighlights = value => {
    if (!Array.isArray(value)) {
        return undefined;
    }
    const cleaned = value
        .map(item => String(item || '').trim())
        .filter(Boolean)
        .slice(0, 8);
    return cleaned.length > 0 ? cleaned : undefined;
};

const sanitizeString = (value, fallback = '') => {
    const normalized = String(value || '').trim();
    return normalized || fallback;
};

const sanitizeAllowedPlanTypes = value => {
    if (!Array.isArray(value)) {
        return undefined;
    }

    const cleaned = value
        .map(planType => String(planType || '').trim().toUpperCase())
        .filter(Boolean);

    return cleaned.length > 0 ? Array.from(new Set(cleaned)) : undefined;
};

export const buildFeatureUpgradeModalConfig = (options = {}) => {
    const presetKey = String(options?.preset || '').trim();
    const presetConfig = PRESET_CONFIG[presetKey] || {};
    const highlights = sanitizeHighlights(options?.highlights) || presetConfig.highlights || DEFAULT_HIGHLIGHTS;

    return {
        preset: presetKey || undefined,
        upgradeType: sanitizeString(options?.upgradeType, 'personal'),
        badge: sanitizeString(options?.badge, presetConfig.badge || 'Premium Feature'),
        title: sanitizeString(options?.title, presetConfig.title || 'Unlock this feature'),
        subtitle: sanitizeString(
            options?.subtitle,
            presetConfig.subtitle || 'Upgrade your plan to continue with this feature.'
        ),
        highlights,
        ctaLabel: sanitizeString(options?.ctaLabel, presetConfig.ctaLabel || 'Upgrade Now'),
        planHint: sanitizeString(options?.planHint, presetConfig.planHint || ''),
        allowedPlanTypes: sanitizeAllowedPlanTypes(options?.allowedPlanTypes)
    };
};

export const openFeatureUpgradeModal = (options = {}) => {
    if (typeof window === 'undefined') {
        return;
    }

    const detail = buildFeatureUpgradeModalConfig(options);

    window.dispatchEvent(
        new CustomEvent(FEATURE_UPGRADE_MODAL_OPEN_EVENT, {
            detail
        })
    );
};
